'use strict';

class Login {
  constructor($window, userService, originatorService, I18N, Notification) {
    this.$window = $window;
    this.userService = userService;
    this.originatorService = originatorService;
    this.I18N = I18N;
    this.Notification = Notification;
  }

  $onInit() {
    this.username = null;
    this.passord = null;
    this.mfaRequired = false;
    this.mfaCode = null;
    this.mfaTrust = false;
  }

  cancelMFA() {
    this.mfaCode = null;
    this.mfaRequired = false;
  }

  login() {
    if (this.username && this.password) {
      if (this.mfaCode) {
          // login audit
          this.userService.loginWithMFACode(this.username, this.password, this.mfaCode, this.mfaTrust)
            .then(() => {
            // autoselect first originator if there is only one
            this.userService.getLinkedOriginators()
            .then((resp) => {
            if (resp && resp.data) {
            // but redirect to the select page if more
            if (resp.data.items.length === 0) {
              this.Notification.error(this.I18N.user.error.accountDeleted);
            } else if (resp.data.items.length > 1) {
              this.$window.location.href = `/side/#/bytt-konto`;
            } else {
              const originator = resp.data.items[0];
              this.$window.sessionStorage.setItem('originatorId', originator.id);

              // originator select audit
              this.originatorService.select(originator.id)
                .then(() => {
                if (originator.state === 'CLOSED_RETURN_MAIL') {
                // STATE 8
                this.$window.location.href = '/side/#/konto/bekreft?error=adresse';
              } else if (originator.state === 'CLOSED_WRONG_EMAIL') {
                // STATE 6
                this.$window.location.href = '/side/#/konto/bekreft?error=epost';
              } else {
                this.$window.location.href = '/side/#/beslutning-kreves';
              }
            });
            }
          }
        })
        .catch(() => {
          this.$window.sessionStorage.removeItem('originatorId');
          this.Notification.error(this.I18N.user.error.login);
        });
        })
        .catch((err) => {
          if (err.status === 412) {
            this.mfaRequired = true;
          } else {
            this.Notification.error(this.I18N.user.error.loginWithMFA);
          }
        });
      } else {
          // login audit
          this.userService.login(this.username, this.password)
            .then(() => {
            // autoselect first originator if there is only one
            this.userService.getLinkedOriginators()
            .then((resp) => {
            if (resp && resp.data) {
            // but redirect to the select page if more
            if (resp.data.items.length === 0) {
              this.Notification.error(this.I18N.user.error.accountDeleted);
            } else if (resp.data.items.length > 1) {
              this.$window.location.href = `/side/#/bytt-konto`;
            } else {
              const originator = resp.data.items[0];
              this.$window.sessionStorage.setItem('originatorId', originator.id);

              // originator select audit
              this.originatorService.select(originator.id)
                .then(() => {
                if (originator.state === 'CLOSED_RETURN_MAIL') {
                // STATE 8
                this.$window.location.href = '/side/#/konto/bekreft?error=adresse';
              } else if (originator.state === 'CLOSED_WRONG_EMAIL') {
                // STATE 6
                this.$window.location.href = '/side/#/konto/bekreft?error=epost';
              } else {
                this.$window.location.href = '/side/#/beslutning-kreves';
              }
            });
            }
          }
        })
        .catch(() => {
          this.$window.sessionStorage.removeItem('originatorId');
          this.Notification.error(this.I18N.user.error.login);
        });
        })
        .catch((err) => {
          if (err.status === 412) {
            this.mfaRequired = true;
          } else {
            this.Notification.error(this.I18N.user.error.login);
          }
        });
      }
    }
  }
}

Login.$inject = ['$window', 'userService', 'originatorService', 'I18N', 'Notification'];

const login = {
  controller: Login,
  template: `
    <fieldset>
      <form name="loginForm" ng-submit="$ctrl.login()" novalidate>
        <div ng-show="!$ctrl.mfaRequired">
          <label for="email">E-postadresse</label>
          <input type="email" id="email" name="email" autocomplete="email" ng-model="$ctrl.username" ng-trim="true" maxlength="64" placeholder="ola@nordmann.no" autofocus required>
        </div>

        <div ng-show="!$ctrl.mfaRequired" role="alert" ng-messages="loginForm.email.$error" ng-if="loginForm.email.$dirty">
          <div ng-messages-include="/side/generic-messages.html"></div>
        </div>

        <div ng-show="!$ctrl.mfaRequired">
          <label for="password">Passord</label>
          <input type="password" id="password" name="password" autocomplete="current-password" ng-model="$ctrl.password" placeholder="minst 8 tegn" required>
        </div>

        <div ng-show="!$ctrl.mfaRequired" role="alert" ng-messages="loginForm.password.$error" ng-if="loginForm.password.$dirty">
          <div ng-messages-include="/side/generic-messages.html"></div>
        </div>

        <div ng-show="$ctrl.mfaRequired">
          <label for="mfaCode" data-balloon-length="large" data-balloon="Informasjonskapsler fra sendregning.no må være lagret. Dersom informasjonskapslene ikke lagres, f. eks. ved bruk av privat-modus eller, eller pga. innstillinger i nettleseren, må koden skrives inn hver gang.
" >Tofaktorautentiseringskode
                <i class="fa fa-question-circle"></i>
              </label>

          <input type="number" id="mfaCode" name="mfaCode" ng-model="$ctrl.mfaCode" maxlength="6" placeholder="123456" autofocus required>
          <label for="mfaTrust">
            <input type="checkbox" id="mvaTrust" name="mfaTrust" ng-model="$ctrl.mfaTrust">
            Husk meg i denne nettleseren
          </label>


        </div>

        <button type="submit" class="button">Logg inn</button>
        <a ng-show="$ctrl.mfaRequired" role="button" class="button secondary" ng-click="$ctrl.cancelMFA()">Avbryt</a>
      </form>
    </fieldset>
  `
};

angular
  .module('SendRegning')
  .component('login', login);
